import React, { useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import { cdrAPI } from "../../../../utils/funcionesAPI";
import { manejadorDeRespuesta, isLogged, calcularSeguroDeCancelacion } from "../../../../utils/Tools";
import TarjetasBancoCuotasPedraza from "../../../Global/TarjetasBancoCuotasPedraza";
import TotalConTarjeta from "../../../Global/TotalConTarjeta";
import { toast } from "react-toastify";
import LoaderFormal from "../../../Global/LoaderFormal";
import ReactGA from "react-ga";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import SeguroCancelacion from "./seguroCancelacion";
import TerminosYPoliticas from "../../../ProcesoCompra/Pago/terminosYpoliticas";

import CuadroTarjeta from "./cuadroTarjeta";
import { CdrGlobalContext } from "../../../../context/cdrGlobalContext";
import LayoutCompra from "../../../Global/LayoutCompra";
import { SET_SEGURO_CANCELACION, SET_INTERES } from "../../../../context/constantes";
import get from "../../../../utils/get";

const PagoCdr = (props) => {
  const [idMedioDePago, ] = useState(3);

  const [
    importeAPagarConImpuestosYIntereses,
    setImporteAPagarConImpuestosYIntereses,
  ] = useState(0);
  const [importeProporcionalRGPais, ] = useState(0);
  const [terminos, setTerminos] = useState(false);
  const [loader, setLoader] = useState(false);
  const [habilitarBoton, setHabilitarBoton] = useState("ok");
  const [textoBoton, setTextoBoton] = useState("pagar");
  const [tarjetaElegida, setTarjetaElegida] = useState({ id: 0 });
  const [cuotaElegida, setCuotaElegida] = useState({
    id: 0,
    cantidad: 0,
    interes: 0,
  });
  const [idBancoElegido, setIdBancoElegido] = useState(0);
  
  if (!isLogged()) props.history.push("/hoteles/proceso-compra/login/");
 
  const [state, dispatch] = useContext(CdrGlobalContext);
  const { 
    productoSeleccionado: producto, 
    pasajerosAdultos, 
    pasajerosMenores, 
    totalCompra, 
    totalRegimen,
    totalSeguroCancelacion, 
    cdrOfertas,
    busquedaCDR
  } = state || {};

  if (Object.keys(producto).length === 0) props.history.push("/hoteles/listado-de-hoteles/");

  //const [importeAPagar, setImporteAPagar] = useState(totalCompra);

  const {
    impuestoPais = 0
  } = props;

  /*
  const resetearTotales = () => {
    setImporteAPagar(calcularTotalPaquete());
    setImporteAPagarConImpuestosYIntereses(calcularTotalPaquete());
    setImporteProporcionalRGPais(impuestoPais);
    setCuotaElegida({ id: 0, cantidad: 0, interes: 0 });
  };
  */
  /*
  const handleMedioDePagoChange = (e) => {
    //si tiene el impuesto que aplica a todo
    if (producto.impuestoPAIS.coeficiente === 0) {
      if (e.target.value === "3") {
        props.onClickPagoConTarjetaConImpuesto(); //re calaculo totales CON impuesto si es tarjeta
        //this.handleRecalcularProporcionalImpuesto();
        //this.setState({idMedioDePago: e.target.value, bancoElegido: 0})
      } else {
        props.onClickPagoEfvoDepoConImpuesto(); //re calculo totales SIN impuestos si no es tarjeta
        //this.setState({idMedioDePago: e.target.value, importeAPagar: this.calcularTotalPaquete(), importeAPagarConImpuestosYIntereses: this.calcularTotalPaquete(), importeProporcionalRGPais: 0})
      }
    } 
    setIdMedioDePago(e.target.value);
    resetearTotales();
  };
  */
 /*
  const handleImporteAPagarChange = (e) => {
    const numberWithoutDot = e.target.value.replace(',','');
    //handleRecalcularProporcionalImpuesto(numberWithoutDot);
    setImporteAPagar(numberWithoutDot);
  };
*/
  const handleTarjetaClick = (tarjetaEleg, cuotaElegida) => {
    setTarjetaElegida(tarjetaEleg);
    setCuotaElegida(cuotaElegida);
  };

  const handleBancoClick = (idBancoElegido) => {
    setIdBancoElegido(idBancoElegido);
  };

  const handleCuotaClick = (cuotaEleg) => {
    const subTotalImporteMasImpuesto =
      parseFloat(totalCompra) + parseFloat(importeProporcionalRGPais);
    const nuevoImporteAPagar =
      subTotalImporteMasImpuesto +
      parseFloat((subTotalImporteMasImpuesto * cuotaEleg.interes) / 100);
    const interesesCuota = parseFloat(totalCompra) * parseFloat(cuotaEleg.interes / 100);
    setCuotaElegida(cuotaEleg);
    //setImporteAPagar(nuevoImporteAPagar);
    setImporteAPagarConImpuestosYIntereses(nuevoImporteAPagar);
    dispatch({type: SET_INTERES, payload: {interes: interesesCuota }});
  };

  const handleIncluirSeguroDeCancelacionClick = (e) => {
    if (e.target.checked === true) {
      mostrarLoader(true);
      calcularSeguroDeCancelacion(totalCompra - producto.gastoDeReserva - totalRegimen, dispatch, cuotaElegida.interes);
      setTimeout(function () {
        
        mostrarLoader(false);
      }, 2000);
    } else {
      dispatch({type: SET_SEGURO_CANCELACION, payload: {totalSeguro:-Math.abs(totalSeguroCancelacion), interes: cuotaElegida.interes }});
    }
  };
  /*
  const handlePasoPagarClick = (e) => {
    props.onPasoPagarClick();
  };
  */
  const mostrarLoader = (estado) => {
    setLoader(estado);
  };

  const handlePreReservarClick = (e) => {
    e.preventDefault();
    const medioPago = Number(idMedioDePago);

    if (medioPago === 3) {
      confirmAlert({
        title: "Pago con Tarjeta de Crédito",
        message:
          "En unos instantes será redirigido a para realizar el pago de su reserva. Por favor no cierre el navegador en esta instancia ¿Está seguro de continuar?",
        buttons: [
          {
            label: "Si",
            onClick: () => {
              handleReservarClick(e);
            },
          },
          {
            label: "No",
            onClick: () => {
              return;
            },
          },
        ],
      });
    } else {
      handleReservarClick(e);
    }
  };

  const handleReservarClick = (e) => {
    e.preventDefault();

    const tokenEnSesion = sessionStorage.getItem("token");
    const medioPago = Number(idMedioDePago);
    const totalOriginal = totalCompra; //calcularTotalPaquete();

    if (!terminos) {
      toast.info(
        "Debe aceptar los Términos y Condiciones",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }

    if (!medioPago) {
      toast.info("Debe seleccionar algún medio de pago", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    /*
    if (medioPago === 3 && parseFloat(importeAPagar) < totalOriginal * 0.3) {
      toast.info("Debe abonar al menos el 30% del total de la reserva", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    */

    if (medioPago === 3 && cuotaElegida.id === 0) {
      toast.info("Debe seleccionar un plan de cuotas", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    let pasajeros = pasajerosAdultos.concat(pasajerosMenores);

    //usuarioWeb: usuario, $idchar, $idprodcab, $cantidad, $cantidadadult, $desde, $codcli, $stok, $idcliente, $habitacion, $cantidadinfoa, 'M'
    if (Object.keys(pasajeros[0]).length === 0) pasajeros = [];

    setTextoBoton("procesando...");
    setHabilitarBoton("");

    const reserva = {
      producto,
      cdrOfertas,
      pasajeros,
      medioDePago: medioPago,
      totalOriginal: totalOriginal,
      importeAPagar: totalCompra,
      cuotas: cuotaElegida,
      tarjeta: tarjetaElegida,
      canal: "CDR",
      idBancoElegido: idBancoElegido,
      totalSeguroCancelacion: totalSeguroCancelacion,
      fechaIn: busquedaCDR.fechaIn,
      fechaOut: busquedaCDR.fechaOut
    };

    const data = JSON.stringify({
      peticion: 'generarReservaCdrPorFirstData',
      reserva: reserva,
      token: tokenEnSesion,
    });

    // ReactGA.initialize("UA-54854159-9");

    mostrarLoader(true);

    cdrAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        //FC: evento de Reservar
        ReactGA.event({
          category: "Reservas",
          action: "Reservar",
        });

        if (medioPago === 3) {
          toast.success("Redirigiendo...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          //FC: para FIRST DATA
          window.location.href = respuesta.data.data;
        } else {
          props.onReservarClick(respuesta.data, medioPago);
        }
      } else {
        setHabilitarBoton("ok");
        setTextoBoton("Pagar");
        //stockEnDemanda(9);
      }
      mostrarLoader(false);
    });
  };

  return (
    <LayoutCompra paso="3">
      <div className="title">
        <LoaderFormal loaded={loader} mensaje="Abriendo..." />
        <br />
        <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 payment clearfix">
          <h2>Pago</h2>
          <hr />
          <h4>
            <i className="material-icons iconos-pagos">payment</i> elija el
            m&eacute;todo de pago
          </h4>
          <ul className="row">

            <CuadroTarjeta
              idMedioDePago={idMedioDePago}
              onMedioDePagoChange={() => {}}
              codigoMoneda={get(producto, 'moneda.codigoMoneda', 'PES')}
              classes={{ contenedorTarjeta: 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12' }}
            >
              <div>
                <TarjetasBancoCuotasPedraza
                  cuotaElegida={cuotaElegida}
                  tarjetaElegida={tarjetaElegida}
                  onTarjetaClick={handleTarjetaClick}
                  onBancoClick={handleBancoClick}
                  onCuotaClick={handleCuotaClick}
                  producto={producto}
                />
              </div>
            </CuadroTarjeta>

          </ul>

          <TotalConTarjeta
            cuotaElegida={cuotaElegida}
            totalPaquete={totalCompra}
            impuestoPais={impuestoPais}
            importeAPagar={totalCompra}
            importeProporcionalRGPais={importeProporcionalRGPais}
            importeAPagarConImpuestosYIntereses={
              importeAPagarConImpuestosYIntereses
            }
          />

        </section>
        <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 terms clearfix">
          <SeguroCancelacion
            onIncluirSeguroDeCancelacionClick={
              handleIncluirSeguroDeCancelacionClick
            }
          />
          <TerminosYPoliticas
            setTerminos={setTerminos}
            terminos={terminos}
          />

          <br />
          <button
            type="submit"
            disabled={!habilitarBoton}
            onClick={handlePreReservarClick}
            className="submitCargaPasajeros"
          >
            {textoBoton}
          </button>
          <div className="listado">
            <Link to='#' onClick={() => props.history.goBack()}>Volver al Paso 2</Link>
          </div>
        </section>
      </div>
    </LayoutCompra>
  );
};

export default withRouter(PagoCdr);




// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/PagoCdr/index.js